import { createActions } from '../utils/actions';

const { actions: notifications } = createActions('notifications')
  .add('add')
  .add('remove');

export default notifications;
